import React from 'react';
import type { ViewStyle } from 'react-native';

import { AudioPlayer } from './audio-player';
import { useSoundContext } from '../../hooks/use-sound-context';

export interface AudioPlayerWithContextProps {
  activeColor?: string;
  inactiveColor?: string;
  barContainerColor?: string;
  barActiveColor?: string;
  isTextProgressVisible?: boolean;
  containerStyle?: ViewStyle;
  onReproduce?: () => void;
  isSlowButtonVisible?: boolean;
}
export const AudioPlayerWithContext: React.FC<AudioPlayerWithContextProps> = (
  props
) => {
  const sound = useSoundContext();

  return <AudioPlayer {...props} sound={sound} />;
};
